import { adminInstance } from "@/api/instance";

export default async function (b4aId) {
  return adminInstance.get(`/b4a/${b4aId}`);
}
